import { Event_ } from '../Event_';
export class KeyboardEvent_ extends Event_ {
    get key() {
        return this.reactEvent.key;
    }
    get inputValue() {
        if (!this.reactEvent.nativeEvent.srcElement)
            return '';
        return this.reactEvent.nativeEvent.srcElement.value;
    }
}
